<div class="pos-abs wrapper-notis">
    <div class=" title "><h6>Уведомления</h6>
        <span (click)="onClear()" class="cup">{{list.length ? 'Очистить' : 'Уведомлений нет'}}</span></div>
    <ul>
        <li *ngFor="let n  of list" [class.read]="!!n.read_at">
            <div class="notis-title">
                <div><nb-icon [icon]="getIcon(n.data.like)"></nb-icon> {{n.data.title}}</div>
                <div>{{n.created_at | date: 'dd.MM.yyyy HH:mm'}}</div>
            </div>
            <div class="notis-desc">
                <div>{{n.data.message}}</div>
            </div>

        </li>
    </ul>
</div>
